/** Mirrors the server rule in lib/marketplace/vendorPassword.js (passwordProblem). */
export const PASSWORD_HINT = 'At least 10 characters, with letters and a number.';
